import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			Oni diras, ke ĉio dependas de la ĉirkaŭo. Ke kia estas nia ĉirkaŭo, tiaj ankaŭ ni formiĝas.
		</p>
		
		<p class="mb-3">
			Sed ne ĉiam okazis tiel. Jen, ekzemple, ĉe la truo la ĉirkaŭo povas esti ora, brokata – sed la truo tutegale restos malplena loko, malplenaĴo, neniaĴo.
		</p>
		`
	)
}

const itemName = {
	esp: 'La ĉircaŭo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;